import {useState} from 'react';
import './AdminQuizes.scss';
import AdminTableCategories from "./AdminTableCategories/AdminTableCategories";
import AdminTableSubCategories from "./AdminTableSubCategories/AdminTableSubCategories";
import AdminTableQuizes from "./AdminTableQuizes/AdminTableQuizes";
import AdminTableQuestions from "./AdminTableQuestions/AdminTableQuestions";

import AdminTableAnswers from "./AdminTableAnswers/AdminTableAnswers";
import AdminTableAnswersForType2 from './AdminTableAnswersForType2/AdminTableAnswersForType2';
import AdminTableAnswersForType3 from './AdminTableAnswersForType3/AdminTableAnswersForType3';
import AdminTableAnswersForType4 from './AdminTableAnswersForType4/AdminTableAnswersForType4';

import InputFormsForAnswers  from './InputForms/InputFormsForAnswers';
import InputFormsForAnswersType2  from './InputForms/InputFormsForAnswersType2';
import InputFormsForAnswersType3  from './InputForms/InputFormsForAnswersType3';
import InputFormsForAnswersType4  from './InputForms/InputFormsForAnswersType4';

import InputFormsForQuestions  from './InputForms/InputFormsForQuestions';
import InputFormsForQuizes  from './InputForms/InputFormsForQuizes';
import InputFormsForSubCategories  from './InputForms/InputFormsForSubCategories';
import InputFormsForCategories  from './InputForms/InputFormsForCategories';
import AddInputFormsForCategories  from './InputForms/AddInputFormsForCategories';
import DeleteInputForms  from './InputForms/DeleteInputForms';
import AddInputFormsForSubCategories  from './InputForms/AddInputFormsForSubCategories';
import DeleteInputFormsForSubCategories  from './InputForms/DeleteInputFormsForSubCategories';
import AddInputFormsForQuizes  from './InputForms/AddInputFormsForQuizes';
import DeleteInputFormsForQuizes  from './InputForms/DeleteInputFormsForQuizes';
import AddInputFormsForQuestions  from './InputForms/AddInputFormsForQuestions';
import DeleteInputFormsForQuestions  from './InputForms/DeleteInputFormsForQuestions';
import DeleteInputFormsForQuestionsImg  from './InputForms/DeleteInputFormsForQuestionsImg';

import AddInputFormsForAnswers  from './InputForms/AddInputFormsForAnswers';
import AddInputFormsForAnswersType2 from './InputForms/AddInputFormsForAnswersType2';
import AddInputFormsForAnswersType3 from './InputForms/AddInputFormsForAnswersType3';
import AddInputFormsForAnswersType4 from './InputForms/AddInputFormsForAnswersType4';

import DeleteInputFormsForAnswers  from './InputForms/DeleteInputFormsForAnswers';
import AdminNote from './AdminNote/AdminNote';
//import DataNote from './DataNote/DataNote';
import DeleteInputFormsForNotePart from './InputForms/DeleteInputFormsForNotePart';
import DeleteInputFormsForImageNotePart from './InputForms/DeleteInputFormsForImageNotePart';
import QuestionImage from './AdminTableQuestions/QuestionImage/QuestionImage';


const AdminQuizes = (props) =>  {
   
        const [activeTab, setActiveTab] = useState(0);
        const tabData = [
                { label: 'Категории' },
                { label: 'Тесты' },
                { label: 'Вопросы' }
        ];

        // HANDLE SET QUIZES VIEW
        const handleQuizesView = () => {
                setActiveTab(1);
        };
        // HANDLE SET QUESTIONS VIEW
        const handleQuestionsView = () => {
                setActiveTab(2);
        }


        const view = props.viewQuizers;
        const { dispatch} = props;
        const viewNote = props.adminState.openInputFormsForNote;
        console.log(viewNote);
        console.log(view);
        if (view) {
            return (

        <div className="AdminQuizes">
                {/* Панель с кнопками */}
                        <div className="tab-headers">
                                {tabData.map((tab, index) => (
                                <button
                                key={index}
                                className={`tab-btn ${activeTab === index ? 'active' : ''}`}
                                onClick={() => setActiveTab(index)}
                                >
                                {tab.label}
                                </button>
                                ))}
                        </div>
                


            
                <div className="main-container"> 

                 { activeTab === 0 ? <div className='item-container'>      
                        <AdminTableCategories 
                                userId={props.userId}
                                adminState={props.adminState}
                                dispatch={dispatch}
                        />
                        <AdminTableSubCategories 
                                
                                adminState={props.adminState}
                                onClickSubcategory = {handleQuizesView}
                                dispatch={dispatch}
                        />
                </div> : null
                 } 
                 { activeTab === 1 ? <div className='item-container'>     
                       
                        <AdminTableQuizes
                                handleAdminQuizesView={props.handleAdminQuizesView}
                                adminState={props.adminState}
                                onClickQuiz = {handleQuestionsView}
                                dispatch={dispatch}
                        /> 
                </div> : null
                }
                { activeTab === 2 ? <div className='item-container'> 
                <AdminTableQuestions
                        
                        adminState={props.adminState}
                        dispatch={dispatch}
                />                 </div> : null
                }

                
                { ((activeTab === 2) && (props.adminState.sortQuestion === "1") )? <div className='item-container'> 
                <AdminTableAnswers
                        
                        adminState={props.adminState}
                        dispatch={dispatch}
                /> 
                </div> : null
                }
                { ((activeTab === 2) && (props.adminState.sortQuestion === "2") )? <div className='item-container'> 
                <AdminTableAnswersForType2
                        
                        adminState={props.adminState}
                        dispatch={dispatch}
                /> 
                </div> : null
                }
                { ((activeTab === 2) && (props.adminState.sortQuestion === "3") )? <div className='item-container'> 
                <AdminTableAnswersForType3
                        
                        adminState={props.adminState}
                        dispatch={dispatch}
                /> 
                </div> : null
                }
                { ((activeTab === 2) && (props.adminState.sortQuestion === "4") )? <div className='item-container'> 
                <AdminTableAnswersForType4
                        
                        adminState={props.adminState}
                        dispatch={dispatch}
                /> 
                </div> : null
                }




                { props.adminState.openInputForms  ? <InputFormsForAnswers 
                         adminState={props.adminState}
                         dispatch={dispatch}
                /> : null}
                { props.adminState.openInputFormsForAnswersType2  ? <InputFormsForAnswersType2 
                         adminState={props.adminState}
                         dispatch={dispatch}
                /> : null}
                { props.adminState.openInputFormsForAnswersType3  ? <InputFormsForAnswersType3 
                         adminState={props.adminState}
                         dispatch={dispatch}
                /> : null}
                { props.adminState.openInputFormsForAnswersType4  ? <InputFormsForAnswersType4 
                         adminState={props.adminState}
                         dispatch={dispatch}
                /> : null}
                { props.adminState.openInputFormsForQuestions ? <InputFormsForQuestions 
                         adminState={props.adminState}
                         dispatch={dispatch}
                /> : null}         
                { props.adminState.openInputFormsForQuizes ? <InputFormsForQuizes 
                         adminState={props.adminState}
                         dispatch={dispatch}
                /> : null}
                 { props.adminState.openInputFormsForSubCategories ? <InputFormsForSubCategories
                         adminState={props.adminState}
                         dispatch={dispatch}
                /> : null}
                 { props.adminState.openInputFormsForCategories ? <InputFormsForCategories
                         adminState={props.adminState}
                         dispatch={dispatch}
                /> : null}
                { props.adminState.openAddInputFormsForCategories ? <AddInputFormsForCategories
                         adminState={props.adminState}
                         dispatch={dispatch}
                /> : null}
                {props.adminState.openDeleteInputForms ? <DeleteInputForms
                         adminState={props.adminState}
                         dispatch={dispatch}
                /> : null}
                {props.adminState.openAddInputFormsForSubCategories ? <AddInputFormsForSubCategories
                         adminState={props.adminState}
                         userId={props.userId}
                         dispatch={dispatch}
                /> : null}
                {props.adminState.openDeleteInputFormsForSubCategories ? <DeleteInputFormsForSubCategories
                         adminState={props.adminState}
                         dispatch={dispatch}
                /> : null}
                {props.adminState.openAddInputFormsForQuizes ? <AddInputFormsForQuizes
                         userId={props.userId}
                         adminState={props.adminState}
                         dispatch={dispatch}
                /> : null} 
                {props.adminState.openDeleteInputFormsForQuizes ? <DeleteInputFormsForQuizes
                         adminState={props.adminState}
                         dispatch={dispatch}
                /> : null}
                {props.adminState.openAddInputFormsForQuestions ? <AddInputFormsForQuestions
                         adminState={props.adminState}
                         dispatch={dispatch}
                /> : null}
                {props.adminState.openDeleteInputFormsForQuestions ? <DeleteInputFormsForQuestions
                         adminState={props.adminState}
                         dispatch={dispatch}
                /> : null}
                {props.adminState.openDeleteInputFormsForQuestionsImg ? <DeleteInputFormsForQuestionsImg
                         adminState={props.adminState}
                         dispatch={dispatch}
                /> : null}
                {props.adminState.openAddInputFormsForAnswers ? <AddInputFormsForAnswers
                         adminState={props.adminState}
                         dispatch={dispatch}
                /> : null}
                {props.adminState.openAddInputFormsForAnswersType2 ? <AddInputFormsForAnswersType2
                         adminState={props.adminState}
                         dispatch={dispatch}
                /> : null}
                {props.adminState.openAddInputFormsForAnswersType3 ? <AddInputFormsForAnswersType3
                         adminState={props.adminState}
                         dispatch={dispatch}
                /> : null}
                {props.adminState.openAddInputFormsForAnswersType4 ? <AddInputFormsForAnswersType4
                         adminState={props.adminState}
                         dispatch={dispatch}
                /> : null}
                 {props.adminState.openDeleteInputFormsForAnswers ? <DeleteInputFormsForAnswers
                         adminState={props.adminState}
                         dispatch={dispatch}
                /> : null}
                {props.adminState.openPreviewQuestionImgForms ? <QuestionImage
                         adminState={props.adminState}
                         dispatch={dispatch}
                /> : null}

                </div>
        </div>
            )
        } 
         else if (viewNote) {
                console.log('START')
                return (
                        <div className='AdminQuizes'>
                        <AdminNote 
                        dispatch={dispatch}

                        dataNotes = {props.adminState.dataNotes}
                        authData={props.authData}
                        handleAdminQuizesView={props.handleAdminQuizesView}
                        selectedIdNote={props.adminState.selectedIdNote}
                        selectedIdNoteText = {props.adminState.selectedIdNoteText}
                        selectedPartNote={props.adminState.selectedPartNote}

                        adminNoteViewActive = {props.adminState.adminNoteViewActive}
                        adminEditNoteViewActive = {props.adminState.adminEditNoteViewActive}

                        errorNoteImageValidateType = {props.adminState.errorNoteImageValidateType}
                        errorNoteImageValidateSize = {props.adminState.errorNoteImageValidateSize}

                        adminFoldererView = {props.adminState.adminFoldererView}
                        noteAddFiles = {props.adminState.noteAddFiles}
                        selectedIdAddFile = {props.adminState.selectedIdAddFile}
                        errorAddFileValidateType = {props.adminState.errorAddFileValidateType}
                        errorAddFileValidateSize = {props.adminState.errorAddFileValidateSize}

                        adminPdfViewer = {props.adminState.adminPdfViewer}
                        pdfName = {props.adminState.pdfName}
                        openDeleteInputFormsForAddFile = {props.adminState.openDeleteInputFormsForAddFile}
                        />
                       { /*<DataNote 
                        dispatch={dispatch}
                        selectedIdNote={this.props.adminState.selectedIdNote}
                        selectedIdNoteText = {this.props.adminState.selectedIdNoteText}
                        dataNotes = {this.props.adminState.dataNotes}

                        

                        errorNoteImageValidateType = {this.props.adminState.errorNoteImageValidateType}
                        errorNoteImageValidateSize = {this.props.adminState.errorNoteImageValidateSize}
                        
                        
                />*/}
                        <DeleteInputFormsForImageNotePart
                        adminState={props.adminState}
                        dispatch={dispatch}
                        />
                         <DeleteInputFormsForNotePart
                        adminState={props.adminState}
                        dispatch={dispatch}
                        />
                        </div>

                )

        } else {
        return null; }
        
    
}
export default AdminQuizes;